import { Arrange, Button, Container, Text } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import { ANON_CREATOR_SIGNUP_MODAL } from 'constants/modalTypes';

const AnonCreatorSignupBanner = () => {
  const dispatch = useDispatch();

  const openAnonCreatorAuthModal = () => {
    dispatch(openModal(ANON_CREATOR_SIGNUP_MODAL));
  };

  return (
    <Container width="100%" backgroundColor="primary" padding="small">
      <Arrange gap={4} justifyContent="center">
        <Text alignment="center" color="white" fontWeight="medium">
          Sign up to save this video as your own. You can only do this for the
          next 24hrs.
        </Text>
        <Container backgroundColor="white" radius="medium">
          <Button size="small" onClick={openAnonCreatorAuthModal}>
            <Text fontWeight="medium" color="primary">
              Get Loom for Free
            </Text>
          </Button>
        </Container>
      </Arrange>
    </Container>
  );
};

export default AnonCreatorSignupBanner;
